import { lazy, Suspense } from "react";
import { Layout } from "@/components/Layout";
import { OfferHero } from "@/components/OfferHero";
import { ProductGrid } from "@/components/ProductGrid";
import { StructuredData } from "@/components/StructuredData";
import { featuredProducts, getProductBySlug } from "@/lib/catalog";
import { homeFaqs } from "@/lib/faqs";
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, SITE_URL } from "@/lib/site";
import { buildHomeStructuredDataGraph } from "@/lib/structuredData";
import { usePageSEO } from "@/lib/usePageSEO";

const FaqSection = lazy(() => import("@/components/FaqSection").then((mod) => ({ default: mod.FaqSection })));
const YberaReviews = lazy(() => import("@/components/YberaReviews").then((mod) => ({ default: mod.YberaReviews })));

const HERO_SLUGS = [
  "escova-progressiva-300g-fashion-gold",
  "escova-progressiva-fashion-gold-500g",
];

export default function Index() {
  const featured = featuredProducts();
  const heroProducts = HERO_SLUGS.map((slug) => getProductBySlug(slug)).filter(
    (product): product is NonNullable<typeof product> => Boolean(product),
  );

  usePageSEO({
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    canonical: `${SITE_URL}/`,
  });

  return (
    <Layout>
      <StructuredData id="home" data={buildHomeStructuredDataGraph()} />
      <OfferHero
        eyebrow="Fashion Gold · Ybera Paris"
        h1="Progressiva Fashion Gold sem formol"
        h1Highlight="Escova 300g e 500g · parceiro oficial Ybera"
        subtitle="Selante potencializador que reduz volume e frizz com brilho de salão. Escolha o tamanho e compre na loja oficial Ybera com o desconto especial de parceiro oficial — nota fiscal da fábrica, sem WhatsApp."
        imageAlt="Escova Progressiva Fashion Gold 300g Ybera Paris"
        products={heroProducts}
      />

      <ProductGrid
        title="Kits e manutenção"
        subtitle="Protect Poo e kits pós-progressiva para prolongar o liso. Escolha o produto e compre na loja oficial Ybera com nosso desconto especial de parceiro oficial."
        products={featured}
      />

      <Suspense fallback={null}>
        <YberaReviews />
      </Suspense>

      <Suspense fallback={null}>
        <FaqSection items={homeFaqs} />
      </Suspense>
    </Layout>
  );
}
